<div class="modal-header bg-primary">
    <h4 class="modal-title text-white">Totaldocs</h4>
    <button type="button" class="close text-white" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body bg-white">
    <p>{{ message }}</p>
</div>
<div class="modal-footer bg-white">
    <button type="button" class="btn btn-primary" (click)="activeModal.close('Close click')">OK</button>
</div>